/**
 * @module eventBus
 * 
 * @description
 * The event bus/publish-subscribe pattern is a way of getting
 * unrelated sections of the application to talk to each other
 */

import Vue from 'vue';
export const eventBus = new Vue();
